import React from "react";
import { Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { useTranslation } from "react-i18next"; // Importer useTranslation

const AccessRequest = ({ request, handleAccept, handleReject, student }) => {
  const navigate = useNavigate();
  const { t } = useTranslation(); // Assigner useTranslation à {t}

  return (
    <Card
      className="mb-3 shadow-sm"
      style={{
        backgroundColor: request.status === "pending" ? "white" : "lightgray",
      }}
    >
      <Card.Body className="d-flex align-items-center justify-content-between">
        <div>
          <h5 className="mb-1">
            {request.user.first_name} {request.user.last_name}
          </h5>
          <p className="mb-1 text-muted">{request.user.email}</p>
          <p className="mb-1">
            <strong>{t("program")}:</strong> {request.program.title}
          </p>
        </div>
        {request.status === "accepted" && student === true && (
          <Button
            variant="success"
            className="me-2"
            onClick={() => navigate(`/programs/${request.program._id}`)}
          >
            {t("view_course")} <FaArrowRight />
          </Button>
        )}

        <div className="text-center">
          <p
            className={`badge ${
              request.status === "pending"
                ? "bg-warning"
                : request.status === "accepted"
                ? "bg-success"
                : "bg-danger"
            }`}
          >
            {t(request.status)}
          </p>
          <p className="text-muted small">
            {new Date(request.created_at).toLocaleDateString()}
          </p>
        </div>
        {student === true ? null : (
          <div>
            <Button
              variant="success"
              className="me-2"
              onClick={handleAccept}
              disabled={request.status !== "pending"}
            >
              {t("accept")}
            </Button>
            <Button
              variant="danger"
              onClick={handleReject}
              disabled={request.status !== "pending"}
            >
              {t("reject")}
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default AccessRequest;
